//获取打点地点信息
import { getShowLocationListAPI } from '@/apis/showLocation'
import { useState, useEffect } from 'react'

function useShowLocationList() {
    const [showLocationList, setShowLocationList] = useState([])
    useEffect(() => {
        const getShowLocationList = async () => {
            const res = await getShowLocationListAPI()
            setShowLocationList(res.data)
        }
        getShowLocationList()
    }, [])
    return {
        showLocationList
    }
}

export { useShowLocationList } 